/* Presentation only. Cookiebot and the existing bridge remain the consent writers. */
(function () {
  'use strict';
  if (window.WscCookieUI) return;
  var root = document.documentElement;
  var opening = false;
  var shown = false, focusing = false, consentReady = false, subscribers = [];

  function dialog() { return document.getElementById('CybotCookiebotDialog'); }
  function interactionRoot() {
    var node = dialog(), wrapper = document.getElementById('CybotCookiebotDialogWrapper');
    return wrapper && wrapper.contains(node) ? wrapper : node;
  }
  function isOpen() {
    var node = dialog();
    var wrapper = document.getElementById('CybotCookiebotDialogWrapper');
    if (!node || !node.isConnected) return false;
    var parts = wrapper && wrapper.contains(node) ? [node, wrapper] : [node];
    if (parts.some(function (el) {
      var style = window.getComputedStyle(el);
      return el.getAttribute('aria-hidden') === 'true' || style.display === 'none' ||
        style.visibility === 'hidden';
    })) return false;
    return parts.some(function (el) { return el.classList.contains('CybotCookiebotDialogActive'); });
  }
  function focusDialog() {
    var node = dialog();
    if (!node || !isOpen() || focusing || interactionRoot().contains(document.activeElement)) return;
    focusing = true;
    try { node.focus({preventScroll: true}); } finally { focusing = false; }
  }
  function notify() { subscribers.slice().forEach(function (fn) { fn(); }); }
  function sync() {
    var active = isOpen();
    if (!active) {
      root.classList.remove('wsc-cmp-open');
      shown = false;
      notify();
      return;
    }
    root.classList.add('wsc-cmp-open');
    if (!shown) {
      shown = true;
      // Adopt the vendor's visible dialog immediately, without hiding it again.
      focusDialog();
    }
    notify();
  }
  function deferSync() {
    setTimeout(function () { opening = false; sync(); }, 0);
  }
  window.addEventListener('CookiebotOnDialogDisplay', function () {
    opening = true;
    notify();
    deferSync();
  });
  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (event) {
    window.addEventListener(event, function () { consentReady = true; deferSync(); });
  });
  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    var outside = !interactionRoot().contains(event.target);
    if (outside && ['Tab', 'Enter', ' ', 'Escape'].indexOf(event.key) !== -1) {
      event.preventDefault(); event.stopImmediatePropagation(); focusDialog();
    }
  }, true);
  document.addEventListener('focusin', function (event) {
    if (isOpen() && !interactionRoot().contains(event.target)) { focusDialog(); }
  }, true);
  ['click', 'dblclick', 'contextmenu'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (isOpen() && !interactionRoot().contains(event.target)) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
  });
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      // Do not cancel native touch panning or wheel scrolling through the veil.
      if (isOpen() && !interactionRoot().contains(event.target)) event.stopImmediatePropagation();
    }, {capture: true, passive: true});
  });
  var observer = new MutationObserver(function (records) {
    if (opening) return; // Vendor adds the active class after its display event.
    var node = dialog();
    var wrapper = document.getElementById('CybotCookiebotDialogWrapper');
    if (records.some(function (record) {
      if (record.type === 'attributes') return record.target === node || record.target === wrapper;
      return !node || Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (el) {
        return el.nodeType === 1 && (el.id === 'CybotCookiebotDialog' ||
          el.id === 'CybotCookiebotDialogWrapper' || (el.contains && el.contains(node)));
      });
    })) sync();
  });
  observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden']});

  function consentSignature() {
    var bot = window.Cookiebot, c = bot && bot.consent;
    if (!bot || bot.hasResponse !== true || !c || c.method !== 'explicit' ||
        ['preferences', 'statistics', 'marketing'].some(function (key) { return typeof c[key] !== 'boolean'; })) return null;
    return [c.preferences, c.statistics, c.marketing].map(function (value) { return value ? '1' : '0'; }).join('');
  }
  function createOfferGate(options) {
    var key = 'wsc_offer_consent_wait_v1', delay = options.delayMilliseconds || 20000;
    var timer, marker, ready = false, paused = false, storageAvailable = true;
    function read() {
      var value;
      try { value = window.sessionStorage.getItem(key); } catch (_) { storageAvailable = false; return null; }
      try { return JSON.parse(value); } catch (_) { return null; }
    }
    function save() { try { window.sessionStorage.setItem(key, JSON.stringify(marker)); } catch (_) { storageAvailable = false; } }
    function clear() { marker = null; try { window.sessionStorage.removeItem(key); } catch (_) {} }
    function valid(value, signature, now) {
      return value && value.v === 1 && value.signature === signature &&
        Number.isFinite(value.started) && Number.isFinite(value.deadline) &&
        value.deadline - value.started === delay && value.started <= now && now - value.started < 86400000;
    }
    function canShow() {
      var signature = consentSignature();
      return ready && storageAvailable && options.canPersist() && !paused && !opening && !isOpen() && valid(marker, signature, Date.now()) &&
        signature !== null && Date.now() >= marker.deadline;
    }
    function suspend() { ready = false; clearTimeout(timer); options.suspend(); }
    function refresh() {
      clearTimeout(timer);
      var signature = consentSignature(), now = Date.now();
      if (!storageAvailable || !options.canPersist()) { suspend(); return; }
      if (paused || opening || isOpen() || signature === null) {
        suspend();
        // A new page can initialize before Cookiebot restores its saved response.
        // Keep the corroborated deadline until the CMP actually knows the choice.
        if (!paused && (opening || isOpen() || consentReady)) clear();
        return;
      }
      if (!valid(marker, signature, now)) {
        var stored = read();
        marker = valid(stored, signature, now) ? stored : {v: 1, signature: signature, started: now, deadline: now + delay};
        save();
      }
      if (!storageAvailable) { suspend(); return; }
      if (now < marker.deadline) {
        suspend();
        timer = setTimeout(refresh, marker.deadline - now);
      } else if (!ready) {
        ready = true;
        if (canShow()) options.ready();
      }
    }
    subscribers.push(refresh);
    window.addEventListener('pagehide', function () { paused = true; suspend(); });
    window.addEventListener('pageshow', function () { paused = false; refresh(); });
    document.addEventListener('visibilitychange', refresh);
    // Caller assigns the returned gate before ready() can execute for a saved deadline.
    setTimeout(refresh, 0);
    return {canShow: canShow, refresh: refresh};
  }
  window.WscCookieUI = {createOfferGate: createOfferGate};
  // A deferred/late asset must not hide a dialog that is already visible.
  sync();
}());
